require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./article-emedicinehealth-definition.json") })
        }
      }, "path---article-emedicinehealth-definition");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---article-emedicinehealth-definition!./.cache/json/article-emedicinehealth-definition.json
// module id = 338
// module chunks = 231608221292675